import { useQuery } from '@tanstack/react-query'
import React, { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { LOCAL_STORAGE_KEYS } from '../configs/constants'
import ApiService from '../services/api-service'
import { account } from '../services/login/api'
import socketService from '../services/socket-service'
import useAppStore from '../stores/app'
import isValidJWT from '../utils/isValidJWT'

const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const token = useAppStore(state => state.token)
  const setToken = useAppStore(state => state.setToken)
  const setAccountData = useAppStore(state => state.setAccountData)
  const logout = useAppStore(state => state.logout)
  const setSocketVersion = useAppStore(state => state.setSocketVersion)
  const { refetch } = useQuery({
    enabled: false,
    queryKey: ['account'],
    queryFn: async () => {
      const response = await account()
      setAccountData(response)
      return response
    }
  })

  const [showPage, setShowPage] = React.useState(false)

  const [query] = useSearchParams()

  useEffect(() => {
    const handleAppAction = (data: any) => {
      if (data?.type === 'socket.current_version_frontend' && typeof data?.version === 'string' && data.version.trim()) {
        setSocketVersion(data.version)
      }
    }
    (async () => {
      if (token && isValidJWT(token)) {
        ApiService.setToken(token)
        ApiService.setLogout(logout)
        refetch()
        socketService.connect(token)
        socketService.on('app_action', handleAppAction)
        if (['/', '/login'].includes(location.pathname)) {
          const redirect = query.get('redirect')
          if (redirect) {
            navigate(redirect)
          } else {
            navigate('/rides')
          }
        } else {
          navigate(location.pathname)
        }
      } else {
        ApiService.setToken(null)
        ApiService.setLogout(null)
        socketService.close()
        if (['/', '/login'].includes(location.pathname)) {
          navigate('/login')
        } else {
          navigate(`/login?redirect=${location.pathname}`)
        }
      }
      setShowPage(true)
    })()
    return () => {
      socketService.off('app_action', handleAppAction)
    }
  }, [token])

  useEffect(() => {
    const updateTokenEvent = (e: StorageEvent) => {
      if (e.key === LOCAL_STORAGE_KEYS.TOKEN) {
        setToken(e.newValue)
      }
    }
    window.addEventListener('storage', updateTokenEvent)
    return () => window.removeEventListener('storage', updateTokenEvent)
  }, [])

  useEffect(() => () => {
    socketService.close()
  }, [])

  if (!showPage) {
    return (
      <div>
        <h2>LOADING</h2>
      </div>
    )
  }

  return children
}

export default Layout
